import { useEffect, useRef, useState } from "react";

const BG_RESIDENTIAL =
  "https://storage.helloreaddy.io/project_files/f7ad8ebc-337c-4051-ba46-7c55a52544f7/cdf43b9b-b6c8-42d5-9297-9709a17dec32_compressed_ChatGPT-Image-202699-18_40_23.webp";
const VAN_PNG =
  "https://storage.helloreaddy.io/project_files/f7ad8ebc-337c-4051-ba46-7c55a52544f7/25c1d438-74bd-4164-912a-5a1932368b93_compressed_ChatGPT-Image-202699-18_40_11.webp";
const TECH_PNG =
  "https://storage.helloreaddy.io/project_files/f7ad8ebc-337c-4051-ba46-7c55a52544f7/7d29c93b-575c-4b1e-b886-3da3b455af8c_compressed_ChatGPT-Image-2026910-10_38_56.webp";

// Scene 02 — three independent layers
const SCENE02_BG =
  "https://storage.helloreaddy.io/project_files/f7ad8ebc-337c-4051-ba46-7c55a52544f7/aeec2b5e-02aa-4f9f-a6f1-bb519100c3c4_compressed_scene02-background.webp";
const SCENE02_EQUIPMENT =
  "https://storage.helloreaddy.io/project_files/f7ad8ebc-337c-4051-ba46-7c55a52544f7/ddd31199-09d0-4df8-a637-fe5a914beb1d_compressed_scene02-equipment-group.webp";
const SCENE02_TECH =
  "https://storage.helloreaddy.io/project_files/f7ad8ebc-337c-4051-ba46-7c55a52544f7/72334057-25ea-4543-a9f7-ca2ea50f7fb6_compressed_scene02-foreground-technician.webp";

// Scene 03 — three independent layers
const SCENE03_BG =
  "https://storage.helloreaddy.io/project_files/f7ad8ebc-337c-4051-ba46-7c55a52544f7/e00dda63-5a72-4e31-9ffd-8a1d12cd5580_compressed_ChatGPT-Image-2026910-14_07_34-1.webp";
const SCENE03_EQUIPMENT =
  "https://storage.helloreaddy.io/project_files/f7ad8ebc-337c-4051-ba46-7c55a52544f7/9a1c2e4a-9b33-4c69-93ff-c0ea5694faaa_compressed_ChatGPT-Image-2026910-14_07_38-2.webp";
const SCENE03_TECH =
  "https://storage.helloreaddy.io/project_files/f7ad8ebc-337c-4051-ba46-7c55a52544f7/e4396a5d-e6f8-4a71-9bd4-213efce8c618_compressed_ChatGPT-Image-2026910-14_07_38-3.webp";

const BG_NEW_SYSTEM =
  "https://readdy.ai/api/search-image?query=Bright%20modern%20suburban%20home%20exterior%20on%20a%20clear%20sunny%20day%20with%20soft%20blue%20sky%2C%20clean%20driveway%20and%20green%20lawn%2C%20architectural%20real%20estate%20photography%2C%20high%20key%20natural%20lighting%2C%20wide%20cinematic%20framing%2C%20crisp%20detail%2C%20premium%20residential%20neighborhood%20atmosphere%2C%20uncluttered%20airy%20background%20suitable%20for%20HVAC%20service%20marketing%20imagery&width=2000&height=1200&seq=hero-scene-newsystem-01&orientation=landscape";

const BG_MAINTAIN =
  "https://readdy.ai/api/search-image?query=Bright%20contemporary%20living%20room%20interior%20with%20large%20windows%20and%20soft%20natural%20daylight%2C%20light%20wood%20floors%2C%20white%20walls%2C%20subtle%20warm%20accents%2C%20clean%20minimalist%20decor%2C%20spacious%20airy%20composition%2C%20architectural%20interior%20photography%2C%20premium%20residential%20comfort%20feeling%2C%20high%20key%20lighting%2C%20wide%20cinematic%20aspect&width=2000&height=1200&seq=hero-scene-maintain-01&orientation=landscape";

const HVAC_UNIT_PNG =
  "https://readdy.ai/api/search-image?query=Modern%20high%20efficiency%20outdoor%20heat%20pump%20HVAC%20condenser%20unit%20isolated%20on%20pure%20white%20background%2C%20clean%20industrial%20product%20photography%2C%20soft%20studio%20lighting%2C%20crisp%20detail%2C%20light%20gray%20metal%20casing%20with%20subtle%20blue%20accent%2C%20professional%20catalog%20image%2C%20slight%20contact%20shadow%20beneath%2C%20no%20people%20no%20text&width=1200&height=1200&seq=hero-heatpump-unit-01&orientation=squarish";

const THERMOSTAT_PNG =
  "https://readdy.ai/api/search-image?query=Modern%20smart%20thermostat%20device%20mounted%20isolated%20on%20pure%20white%20background%2C%20round%20minimalist%20design%20with%20glowing%20display%20showing%20temperature%2C%20premium%20product%20photography%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20subtle%20contact%20shadow%2C%20professional%20catalog%20image%2C%20clean%20composition%2C%20no%20people%20no%20text&width=1200&height=1200&seq=hero-thermostat-01&orientation=squarish";

// Refined Hero blue: deeper, less saturated, better harmony with navy + photography.
const HERO_BLUE = "#2C55B8";
const HERO_BLUE_DARK = "#22459A";
const HERO_EMBER = "#C8322A";
const HERO_EMBER_DARK = "#E64A20";

type SceneKey = "repair" | "install" | "maintain";

const scenes: {
  key: SceneKey;
  bg: string;
  eyebrow: string;
  title1: string;
  title2: string;
  titleAccent: string;
  sub: string;
  primaryCta: string;
  secondaryCta: string;
  vehicle: string;
  foreground: string;
  /** Height-based container so vehicle is grounded and never floats into header */
  vehicleStyle: string;
  /** Height-based container so technician's head is always visible below header */
  foregroundStyle: string;
}[] = [
  {
    key: "repair",
    bg: BG_RESIDENTIAL,
    eyebrow: "01 · SAME-DAY REPAIR",
    title1: "Comfort,",
    title2: "delivered",
    titleAccent: "today.",
    sub:
      "Fast, honest HVAC repair for Austin homes. A local technician can be at your door within hours — most repairs finished the same afternoon.",
    primaryCta: "Book Same-Day Repair",
    secondaryCta: "See How It Works",
    vehicle: VAN_PNG,
    foreground: TECH_PNG,
    vehicleStyle: "h-[min(62vh,620px)] right-[-10%] bottom-[6%]",
    foregroundStyle: "h-[min(66vh,666px)] right-[14%] bottom-[6%]",
  },
  {
    key: "install",
    bg: SCENE02_BG,
    eyebrow: "02 · NEW SYSTEM",
    title1: "Better comfort",
    title2: "for what's",
    titleAccent: "next.",
    sub:
      "High-efficiency heat pumps and complete HVAC systems, professionally sized for your home. Free in-home estimate, flexible financing.",
    primaryCta: "Get Free Estimate",
    secondaryCta: "See Financing",
    vehicle: SCENE02_EQUIPMENT,
    foreground: SCENE02_TECH,
    vehicleStyle: "h-[min(62vh,640px)] right-[-2%] bottom-[4%]",
    foregroundStyle: "h-[min(78vh,780px)] right-[6%] bottom-0",
  },
  {
    key: "maintain",
    bg: SCENE03_BG,
    eyebrow: "03 · YEAR-ROUND CARE",
    title1: "One tune-up,",
    title2: "a whole",
    titleAccent: "season easier.",
    sub:
      "Seasonal maintenance, air-quality checks, and smart thermostat tuning. Keep your system efficient and your bills predictable.",
    primaryCta: "Start Maintenance Plan",
    secondaryCta: "Learn More",
    vehicle: SCENE03_EQUIPMENT,
    foreground: SCENE03_TECH,
    vehicleStyle: "h-[min(82vh,820px)] right-[1%] bottom-[3%]",
    foregroundStyle: "h-[min(66vh,660px)] right-[26%] bottom-[3%]",
  },
];

type Phase = "idle" | "enter" | "techOut" | "vanOut" | "bgSwap";

const TIME_TECH_OUT = 300;
const TIME_VAN_OUT = 850;
const TIME_BG_SWAP = 500;
const TIME_VAN_IN = 850;
const TIME_TECH_IN_DELAY = 350;
const TIME_TECH_IN = 450;
const TIME_ENTER = TIME_TECH_IN_DELAY + TIME_TECH_IN;

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 1024 : false,
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return isMobile;
}

function MobileHero() {
  const cur = scenes[0];
  return (
    <section className="relative w-full min-h-[640px] overflow-hidden bg-slate-100">
      <div className="absolute inset-0">
        <img src={cur.bg} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/90 via-white/60 to-white/20"></div>
      </div>

      <div className="relative z-10 pt-[140px] pb-6 px-5">
        <div className="inline-flex items-center gap-2 mb-4">
          <span className="inline-flex items-center gap-1.5 text-[10px] font-bold tracking-[0.18em] text-brand-ember bg-white/90 border border-brand-ember/20 px-2.5 py-1 rounded-full">
            <i className="ri-map-pin-fill"></i> AUSTIN, TX
          </span>
          <span className="text-[10px] font-bold tracking-[0.18em] text-brand-navy/70">
            {cur.eyebrow}
          </span>
        </div>
        <h1
          className="font-display text-[40px] leading-[1] tracking-[-0.02em] text-brand-navy"
          style={{ fontWeight: 800 }}
        >
          {cur.title1}
          <br />
          {cur.title2} <span style={{ color: HERO_BLUE }}>{cur.titleAccent}</span>
        </h1>
        <p className="mt-4 text-[15px] leading-relaxed text-brand-navy/75">{cur.sub}</p>
        <div className="mt-5 flex flex-col gap-2.5">
          <a
            href="#book"
            className="inline-flex items-center justify-center gap-2 text-white font-semibold px-5 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors"
            style={{ backgroundColor: HERO_EMBER }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = HERO_EMBER_DARK)}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = HERO_EMBER)}
          >
            <i className="ri-calendar-check-line"></i>
            {cur.primaryCta}
          </a>
          <a
            href="tel:5125550187"
            className="inline-flex items-center justify-center gap-2 bg-white border border-slate-200 text-brand-navy font-semibold px-5 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-phone-fill" style={{ color: HERO_BLUE }}></i>
            {cur.secondaryCta}
          </a>
        </div>
        <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-[12px] text-brand-navy/80">
          {["Licensed & Insured", "Same-Day Service", "4.9 · 2,400+ Reviews"].map((t) => (
            <div key={t} className="flex items-center gap-1.5">
              <span className="w-4 h-4 rounded-full flex items-center justify-center" style={{ backgroundColor: HERO_BLUE }}>
                <i className="ri-check-line text-white text-[10px]"></i>
              </span>
              <span className="font-medium">{t}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="relative w-full h-[340px] mt-2">
        <img
          src={cur.vehicle}
          alt=""
          className="absolute right-[-8%] bottom-0 h-[240px] w-auto object-contain drop-shadow-[0_20px_30px_rgba(11,27,59,0.25)]"
        />
        <img
          src={cur.foreground}
          alt="Technician"
          className="absolute right-[8%] bottom-0 h-[320px] w-auto object-contain"
          style={{
            filter:
              "drop-shadow(1px 0 0 #fff) drop-shadow(-1px 0 0 #fff) drop-shadow(0 1px 0 #fff) drop-shadow(0 -1px 0 #fff) drop-shadow(0 20px 30px rgba(11,27,59,0.35))",
          }}
        />
      </div>
    </section>
  );
}

export default function Hero() {
  const isMobile = useIsMobile();
  const [index, setIndex] = useState(0);
  const [phase, setPhase] = useState<Phase>("enter");
  const [prevBg, setPrevBg] = useState<string | null>(null);
  const [direction, setDirection] = useState<1 | -1>(1);
  const [released, setReleased] = useState(false);
  const lockRef = useRef(false);
  const lastWheelRef = useRef(0);
  const timeoutsRef = useRef<number[]>([]);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (phase === "enter") {
      const t = window.setTimeout(() => setPhase("idle"), TIME_ENTER);
      return () => clearTimeout(t);
    }
  }, [phase]);

  useEffect(() => {
    if (isMobile) return;
    if (!released) {
      const prevOverflow = document.body.style.overflow;
      const prevHtmlOverflow = document.documentElement.style.overflow;
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      window.scrollTo(0, 0);
      return () => {
        document.body.style.overflow = prevOverflow;
        document.documentElement.style.overflow = prevHtmlOverflow;
      };
    }
  }, [released, isMobile]);

  const clearAllTimeouts = () => {
    timeoutsRef.current.forEach((t) => clearTimeout(t));
    timeoutsRef.current = [];
  };

  const goTo = (target: number, dir: 1 | -1) => {
    if (lockRef.current) return;
    if (target < 0 || target >= scenes.length) return;
    lockRef.current = true;
    setDirection(dir);
    const oldBg = scenes[index].bg;

    setPhase("techOut");
    const t1 = window.setTimeout(() => setPhase("vanOut"), TIME_TECH_OUT);
    const t2 = window.setTimeout(() => {
      setPrevBg(oldBg);
      setIndex(target);
      setPhase("bgSwap");
    }, TIME_TECH_OUT + TIME_VAN_OUT);
    const t3 = window.setTimeout(() => {
      setPrevBg(null);
      setPhase("enter");
    }, TIME_TECH_OUT + TIME_VAN_OUT + TIME_BG_SWAP);
    const t4 = window.setTimeout(() => {
      lockRef.current = false;
    }, TIME_TECH_OUT + TIME_VAN_OUT + TIME_BG_SWAP + TIME_ENTER);

    timeoutsRef.current.push(t1, t2, t3, t4);
  };

  useEffect(() => {
    if (isMobile) return;
    const onWheel = (e: WheelEvent) => {
      if (released) return;
      e.preventDefault();
      if (lockRef.current) return;
      if (Math.abs(e.deltaY) < 8) return;
      const now = Date.now();
      if (now - lastWheelRef.current < 250) return;
      lastWheelRef.current = now;

      if (e.deltaY > 0) {
        if (index < scenes.length - 1) {
          goTo(index + 1, 1);
        } else {
          setReleased(true);
        }
      } else if (e.deltaY < 0) {
        if (index > 0) goTo(index - 1, -1);
      }
    };
    const onKey = (e: KeyboardEvent) => {
      if (released) return;
      if (["ArrowDown", "PageDown", "ArrowUp", "PageUp", " "].includes(e.key)) {
        e.preventDefault();
      }
    };
    window.addEventListener("wheel", onWheel, { passive: false });
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("keydown", onKey);
    };
  }, [index, released, isMobile]);

  useEffect(() => {
    if (isMobile) return;
    if (!released) return;
    const onWheel = (e: WheelEvent) => {
      if (e.deltaY < 0 && window.scrollY <= 2) {
        e.preventDefault();
        setReleased(false);
      }
    };
    window.addEventListener("wheel", onWheel, { passive: false });
    return () => window.removeEventListener("wheel", onWheel);
  }, [released, isMobile]);

  useEffect(() => () => clearAllTimeouts(), []);

  // Release scroll lock whenever user navigates via an in-page hash link (e.g. #services)
  useEffect(() => {
    if (isMobile) return;
    const releaseIfHash = () => {
      if (window.location.hash && window.location.hash !== "#") {
        setReleased(true);
      }
    };
    if (window.location.hash && window.location.hash !== "#") {
      setReleased(true);
    }
    const onClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      const a = target.closest("a") as HTMLAnchorElement | null;
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (href.startsWith("#") && href.length > 1) {
        setReleased(true);
      }
    };
    window.addEventListener("hashchange", releaseIfHash);
    document.addEventListener("click", onClick, true);
    return () => {
      window.removeEventListener("hashchange", releaseIfHash);
      document.removeEventListener("click", onClick, true);
    };
  }, [isMobile]);

  if (isMobile) return <MobileHero />;

  const cur = scenes[index];

  const vanOffTransform = "translate3d(-130vw,0,0)";

  const isScene02 = cur.key === "install";
  const isScene03 = cur.key === "maintain";

  const vanStyle: React.CSSProperties = { willChange: "transform, opacity" };
  if (isScene02 || isScene03) {
    if (phase === "enter") {
      vanStyle.animation = `scene02-eq-in 420ms cubic-bezier(0.22,1,0.36,1) both`;
    } else if (phase === "vanOut") {
      vanStyle.animation = `scene02-eq-out 400ms cubic-bezier(0.22,1,0.36,1) both`;
      vanStyle.animationDelay = `120ms`;
    } else if (phase === "techOut") {
      vanStyle.transform = "translate3d(0,0,0)";
      vanStyle.opacity = 1;
    } else if (phase === "bgSwap") {
      vanStyle.opacity = 0;
      vanStyle.transform = "translate3d(0,50px,0)";
    } else {
      vanStyle.transform = "translate3d(0,0,0)";
    }
  } else {
    if (phase === "enter") {
      vanStyle.animation = `van-in-right ${TIME_VAN_IN}ms cubic-bezier(0.16,1,0.3,1) both`;
    } else if (phase === "vanOut") {
      vanStyle.animation = `van-out-left ${TIME_VAN_OUT}ms cubic-bezier(0.7,0,0.84,0) both`;
    } else if (phase === "bgSwap") {
      vanStyle.transform = vanOffTransform;
    } else {
      vanStyle.transform = "translate3d(0,0,0)";
    }
  }
  void direction;

  const techVisible = phase === "idle";
  const textVisible = phase === "idle" || phase === "enter" || phase === "bgSwap";

  return (
    <section
      ref={rootRef}
      className="relative w-full h-screen min-h-[720px] overflow-hidden bg-slate-100"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          key={`bg-${cur.key}`}
          src={cur.bg}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        {prevBg && (
          <img
            src={prevBg}
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
            style={{ animation: `bg-fade-out ${TIME_BG_SWAP}ms ease-in-out forwards` }}
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-r from-white/80 via-white/35 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-white/25 via-transparent to-white/10"></div>
      </div>

      {/* Vehicle — height-capped so it never rises into the header */}
      <div className={`absolute ${cur.vehicleStyle} pointer-events-none`} style={vanStyle}>
        <img
          src={cur.vehicle}
          alt=""
          className="h-full w-auto object-contain"
          style={{
            filter: isScene02 || isScene03
              ? "drop-shadow(1px 0 0 #fff) drop-shadow(-1px 0 0 #fff) drop-shadow(0 1px 0 #fff) drop-shadow(0 -1px 0 #fff) drop-shadow(0 30px 40px rgba(11,27,59,0.25))"
              : "drop-shadow(0 30px 40px rgba(11,27,59,0.25))",
          }}
        />
      </div>

      {/* Technician — height-capped so head stays fully visible below the header safe area */}
      {(() => {
        // Scene 02/03 use a faster, tighter timing just for the solo technician.
        // Scene 01 keeps the original pacing untouched.
        const techInDur = (isScene02 || isScene03) ? 320 : TIME_TECH_IN;
        const techOutDur = (isScene02 || isScene03) ? 260 : TIME_TECH_IN;
        const techInDelay = (isScene02 || isScene03) ? 150 : TIME_TECH_IN_DELAY;
        const dur = techVisible ? techInDur : techOutDur;
        return (
      <div
        className={`absolute ${cur.foregroundStyle} pointer-events-none`}
        style={{
          transition: `transform ${dur}ms cubic-bezier(0.16,1,0.3,1), opacity ${dur}ms ease-out`,
          transform: techVisible
            ? isScene02
              ? "translate3d(0,0,0) scale(0.9)"
              : "translate3d(0,0,0) scale(1)"
            : isScene02
            ? "translate3d(0,80px,0) scale(0.9)"
            : isScene03
            ? "translate3d(-15px,70px,0) scale(1)"
            : "translate3d(0,140px,0) scale(0.96)",
          transformOrigin: "bottom center",
          opacity: techVisible ? 1 : 0,
          transitionDelay: phase === "enter" ? `${techInDelay}ms` : "0ms",
          filter:
            "drop-shadow(1px 0 0 #fff) drop-shadow(-1px 0 0 #fff) drop-shadow(0 1px 0 #fff) drop-shadow(0 -1px 0 #fff) drop-shadow(0 30px 30px rgba(11,27,59,0.35))",
        }}
      >
        <img src={cur.foreground} alt="Technician" className="h-full w-auto object-contain" />
      </div>
        );
      })()}

      {/* Content — no boxed panel, sits directly on background */}
      <div className="relative z-10 max-w-[1400px] mx-auto h-full px-6 md:px-10 flex flex-col justify-center pt-[132px]">
        <div
          className="max-w-[620px] transition-all duration-[700ms] ease-out"
          style={{
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? "translateY(0)" : "translateY(10px)",
          }}
        >
          {/* subtle local readability glow */}
          <div className="absolute -z-10 -inset-x-6 -inset-y-8 bg-[radial-gradient(ellipse_at_left,rgba(255,255,255,0.75),transparent_70%)] pointer-events-none"></div>

          <div className="inline-flex items-center gap-2 mb-6">
            <span className="inline-flex items-center gap-1.5 text-[11px] font-bold tracking-[0.18em] text-brand-ember bg-white/90 border border-brand-ember/20 px-3 py-1.5 rounded-full">
              <i className="ri-map-pin-fill"></i> AUSTIN, TX
            </span>
            <span
              key={`eb-${cur.key}`}
              className="text-[11px] font-bold tracking-[0.18em] text-brand-navy/70"
              style={{ animation: "fade-in 600ms ease-out both" }}
            >
              {cur.eyebrow}
            </span>
          </div>

          <h1
            key={`h-${cur.key}`}
            className="font-display text-[60px] md:text-[80px] leading-[0.92] tracking-[-0.02em] text-brand-navy"
            style={{ fontWeight: 800, animation: "fade-up 800ms ease-out both" }}
          >
            {cur.title1}
            <br />
            {cur.title2} <span style={{ color: HERO_BLUE }}>{cur.titleAccent}</span>
          </h1>

          <p
            key={`p-${cur.key}`}
            className="mt-6 text-[17px] leading-relaxed text-brand-navy/80 max-w-[520px]"
            style={{ animation: "fade-up 800ms 120ms ease-out both" }}
          >
            {cur.sub}
          </p>

          <div
            key={`c-${cur.key}`}
            className="mt-8 flex flex-wrap items-center gap-3"
            style={{ animation: "fade-up 800ms 220ms ease-out both" }}
          >
            <a
              href="#book"
              className="inline-flex items-center gap-2 text-white font-semibold px-6 py-3.5 rounded-md whitespace-nowrap cursor-pointer transition-colors"
              style={{ backgroundColor: HERO_EMBER }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = HERO_EMBER_DARK)}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = HERO_EMBER)}
            >
              <i className="ri-calendar-check-line"></i>
              {cur.primaryCta}
            </a>
            <a
              href="tel:5125550187"
              className="inline-flex items-center gap-2 bg-white/90 border border-slate-200 hover:border-brand-navy text-brand-navy font-semibold px-6 py-3.5 rounded-md whitespace-nowrap cursor-pointer transition-colors"
            >
              <i className="ri-phone-fill" style={{ color: HERO_BLUE }}></i>
              {cur.secondaryCta}
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-[13px] text-brand-navy/85">
            {["Licensed & Insured", "Same-Day Service", "Upfront Pricing", "4.9 · 2,400+ Reviews"].map((t) => (
              <div key={t} className="flex items-center gap-1.5">
                <span className="w-4 h-4 rounded-full flex items-center justify-center" style={{ backgroundColor: HERO_BLUE }}>
                  <i className="ri-check-line text-white text-[10px]"></i>
                </span>
                <span className="font-medium">{t}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scene indicator */}
      <div className="absolute z-20 left-6 md:left-10 bottom-8 flex flex-col gap-2">
        {scenes.map((s, i) => (
          <div key={s.key} className="flex items-center gap-3">
            <div
              className={`h-[2px] transition-all duration-500 ${
                i === index ? "w-10 bg-brand-navy" : "w-4 bg-brand-navy/25"
              }`}
            ></div>
            <span
              className={`text-[10px] tracking-[0.2em] font-bold ${
                i === index ? "text-brand-navy" : "text-brand-navy/40"
              }`}
            >
              0{i + 1}
            </span>
          </div>
        ))}
      </div>

      <div className="absolute z-20 right-6 md:right-10 bottom-8 flex items-center gap-2 text-brand-navy/60 text-[11px] tracking-[0.18em] font-bold">
        SCROLL
        <i className="ri-arrow-down-line animate-bounce"></i>
      </div>

      <style>{`
        @keyframes van-in-right {
          0% { transform: translate3d(120vw, 0, 0); }
          70% { transform: translate3d(-2%, 0, 0); }
          85% { transform: translate3d(1%, 0, 0); }
          100% { transform: translate3d(0, 0, 0); }
        }
        @keyframes van-in-left {
          0% { transform: translate3d(-120vw, 0, 0); }
          70% { transform: translate3d(2%, 0, 0); }
          85% { transform: translate3d(-1%, 0, 0); }
          100% { transform: translate3d(0, 0, 0); }
        }
        @keyframes van-out-left {
          0% { transform: translate3d(0,0,0); }
          100% { transform: translate3d(-130vw, 0, 0); }
        }
        @keyframes van-out-right {
          0% { transform: translate3d(0,0,0); }
          100% { transform: translate3d(130vw, 0, 0); }
        }
        @keyframes bg-fade-out {
          0% { opacity: 1; }
          100% { opacity: 0; }
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scene02-eq-in {
          0% { transform: translate3d(0,55px,0); opacity: 0; }
          100% { transform: translate3d(0,0,0); opacity: 1; }
        }
        @keyframes scene02-eq-out {
          0% { transform: translate3d(0,0,0); opacity: 1; }
          100% { transform: translate3d(0,55px,0); opacity: 0; }
        }
        @keyframes fade-up {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}